import { useAppSelector } from '@/shared/lib/redux'
import { useMemo } from 'react'
import { ChartData, ChartOptions } from 'chart.js'
import {ru} from 'date-fns/locale'
import { selectAggregates } from '../../model'
import { fromNanoToUnit } from '@/entities/bonus'
import { ChartBlock } from '@/shared/ui/chart-block'

export const TransactionsDynamic = () => {
    const aggregates = useAppSelector(selectAggregates)
    
    const data: ChartData<"line"> = useMemo(() => {
        const sortedItems = [...aggregates.items].sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime())
        return {
            labels: sortedItems.map((agg) => agg.time),
            datasets: [
                {
                    label: 'Сумма транзакций',
                    fill: true,   
                    borderColor: 'rgba(5, 205, 153, 0.8)',
                    borderWidth: 2,
                    backgroundColor: function(ctx) {
                        const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 400);
                        gradient.addColorStop(0.01, 'rgb(5, 205, 153,0.7)');
                        gradient.addColorStop(0.7, 'rgb(5, 205, 153,0.1)');
                        return gradient
                    },
                    cubicInterpolationMode: 'monotone',
                    data: sortedItems.map((agg) => fromNanoToUnit(agg.sum_amount_nano))
                }
            ]
        }
    }, [aggregates])
    
    const options: ChartOptions<"line"> = {
        scales: {
            y: {
                ticks: {
                    maxTicksLimit: 10
                },
                border: {
                    dash: [8, 4],
                    color: 'rgba(0, 0, 0, 0)'
                },
            },
            x: {
                type: 'time', 
                time: {
                    unit: 'day',
                    round: 'week',
                    tooltipFormat: 'LLL d, yyyy'
                },
                adapters: {
                    date: {
                        locale: ru
                    }
                },
                grid: {
                    drawOnChartArea: false
                },
                border: {
                    color: 'rgba(0, 0, 0, 0)'
                }
            },
        },
    }

    return (
        <ChartBlock options={options} type="line" chartClass="min-h-[350px]" title="Динамика транзакций" data={data} />
    )
}